module.exports = __webpack_public_path__ + "img/type4.33be5d4e.png";